// extracted by mini-css-extract-plugin
export default {"menuBlock":"VD-z","title":"WD-z","nav":"XD-z","flexCell":"YD-z","facetLink":"ZD-z"};